/**
 * 주어진 날짜의 하루 전 날짜를 계산합니다.
 *
 * @param {string} dateStr - YYYY-MM-DD 형식의 날짜
 * @returns {string} YYYY-MM-DD 형식의 이전 날짜. 입력값이 없거나 유효하지 않으면 빈 문자열
 */
export const getPreviousDate = (dateStr) => {
  if (!dateStr) return ""

  const [year, month, day] = dateStr.split("-").map(Number)
  const date = new Date(year, month - 1, day)

  if (Number.isNaN(date.getTime())) return ""

  date.setDate(date.getDate() - 1)

  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const dd = String(date.getDate()).padStart(2, "0")

  return `${yyyy}-${mm}-${dd}`
}
